import { motion } from "framer-motion";
import { GALLERY } from "./data";
import { Reveal } from "./Reveal";
import { useContent } from "./ContentContext";
import { useTx, txtStyle } from "./siteText";
import { useLightbox } from "./Lightbox";

const EASE = [0.16, 1, 0.3, 1];
// varied tile spans for an editorial masonry feel
const SPANS = ["row-span-2", "", "", "row-span-2", "", "", "", "row-span-2", "", "", "", ""];

export const Gallery = () => {
  const { settings, resolveImg } = useContent();
  const tx = useTx();
  const { show } = useLightbox();
  const items = (settings.gallery && settings.gallery.length ? settings.gallery : GALLERY);
  return (
    <section id="gallery" className="relative py-24 md:py-32 bg-cantina-cream" data-testid="gallery-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <Reveal className="text-center flex flex-col items-center mb-14">
          <p className="font-script text-cantina-terracotta mb-2" style={txtStyle(tx("gallery.eyebrow"))}>{tx("gallery.eyebrow").text}</p>
          <h2 className="font-display tracking-tight text-cantina-ink" style={txtStyle(tx("gallery.heading"))}>{tx("gallery.heading").text}</h2>
          <div className="dash-rule w-28 mt-6" />
        </Reveal>

        <div className="grid grid-cols-2 md:grid-cols-4 auto-rows-[150px] md:auto-rows-[190px] gap-3 md:gap-4">
          {items.map((g, i) => (
            <motion.button
              key={i}
              initial={{ opacity: 0, scale: 0.94 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.55, ease: EASE, delay: (i % 4) * 0.05 }}
              onClick={() => show(items, i)}
              className={`frame-img group relative rounded-2xl overflow-hidden cursor-zoom-in ${SPANS[i % SPANS.length]}`}
              data-testid={`gallery-img-${i}`}
              aria-label={`View ${g.name}`}
            >
              <img src={resolveImg(g.img)} alt={g.name} loading="lazy" className="w-full h-full object-cover" />
              <span className="absolute inset-0 bg-cantina-navydeep/0 group-hover:bg-cantina-navydeep/35 transition-colors duration-500" />
              <span className="absolute left-3 bottom-3 right-3 text-left font-sans text-white opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-500" style={txtStyle(tx("gallery.caption"))}>
                {g.name}
              </span>
            </motion.button>
          ))}
        </div>
      </div>
    </section>
  );
};
